import React from "react";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";

export const TotalProduccion = (props) => {
    const { totalesProduccion = {} } = props;
    const { kgSecosPacas = 0 } = totalesProduccion;

    return (
        <div
            className="d-flex justify-content-center mt-4 mb-4 py-4 px-3 gap-1rem flex-wrap"
            style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
        >
            <div className="d-flex align-items-center gap-10">
                <label className="text-nowrap mb-0 pl-0">
                    Total producido:
                </label>
                <h4 className="text-nowrap mb-0">
                    <RenderKilogramo value={kgSecosPacas} decimals={3} />
                </h4>
            </div>
        </div>
    );
};
